import { Trans } from 'react-i18next';

import { useParamsQuery } from '../hooks/useQueries';

const REAL_ESTATE_AGENT_ACTIVITY_CODE = '683100.a';

export const getRealEstateAgentHintIfApplicable = (): JSX.Element | undefined => {
  const { data } = useParamsQuery();

  const isRealEstateAgentActivitySelected: boolean = !!data?.activities?.find(
    ({ insifyActivityCode }) => insifyActivityCode === REAL_ESTATE_AGENT_ACTIVITY_CODE,
  );

  return isRealEstateAgentActivitySelected ? (
    <Trans
      i18nKey='funnel:activity_hint_real_estate_agents'
      components={{
        a: <a />,
      }}
    ></Trans>
  ) : undefined;
};
